import { render, staticRenderFns } from "./listItems.vue?vue&type=template&id=70dd8257"
import script from "./listItems.vue?vue&type=script&lang=js"
export * from "./listItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports